<template>
  <div>
    <el-container>
      <el-main>
        <div class="box">
          <el-form :inline="true" size="small">
            <el-form-item>
              <el-input v-model.trim="queryParams.iccid" placeholder="请输入卡号" />
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="queryParams.ordName" placeholder="请输入交易名称" />
            </el-form-item>
            <el-form-item>
              <el-input v-model.trim="queryParams.ordNo" placeholder="订单号" />
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="queryParams.ordType" placeholder="预存类型">
                <el-option :value="1" label="充值余额" />
                <el-option :value="2" label="充值流量" />
                <el-option :value="3" label="充值短信" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select @focus="loadAgent" clearable filterable allow-create default-first-option v-model="queryParams.agentId" placeholder="请选择代理商">
                <el-option v-for="i in agents" :key="i.id" :label="i.agentName" :value="i.agentId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item >
              <el-date-picker style="padding-left:3px" v-model="queryParams.startTime" type="datetime" placeholder="选择开始时间" @change="dataSearchSt" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-date-picker v-model="queryParams.endTime" type="datetime" placeholder="选择结束时间" @change="dataSearchEd" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
          </el-form>
          <div>
            <el-button @click="list(1)" size="small" plain type="primary" icon="el-icon-search">搜索</el-button>

            <el-button @click="download" type="primary" plain size="small" icon="el-icon-download">导出</el-button>
          </div>
        </div>

        <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
                  :cell-style="{height:'5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                  border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column label="ID" prop="id" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="iccid" label="ICCID" width="200">
            <template slot-scope="{row}">
              <span>{{row.iccid==='0'?'/':row.iccid}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ordNo" label="订单号" min-width="240">
          </el-table-column>
          <el-table-column prop="agentId" label="代理商" min-width="150">
          </el-table-column>
          <el-table-column prop="ordName" label="交易名称" min-width="150">
          </el-table-column>
          <el-table-column prop="price" label="交易金额" min-width="140">
          </el-table-column>
          <el-table-column prop="packetName" show-overflow-tooltip label="套餐包名称" width="240">
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170">
          </el-table-column>
          <el-table-column prop="info" label="备注" min-width="200">
          </el-table-column>

        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="list" v-bind:itemCount="8"></pagination>

      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'sysOrderPreList',
  components: {
    Pagination
  },

  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },

  data() {
    return {
      maxHeight: 500,
      agents: [],
      tableData: [],
      queryParams:{
        iccid: '',
        ordName:'',
        ordNo:'',
        agentId:'',
        startTime:'',
        endTime:'',
        current:1,
        size:10,
        ordType:'',
      },
      agentJs: require('../../../api/agent'),
      orderJs:require('../../../api/order')
    }
  },

  methods: {

    dataSearchSt(data) {
      this.queryParams.startTime=data
    },
    dataSearchEd(data) {
      this.queryParams.endTime=data
    },
    loadAgent(){
      this.agents=[]
      this.agentJs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agents.push(map)
        })

      })
    },

    list(page) {
      let _this = this
      _this.maxHeight = _this.$listenHeight.getBodyHeight()
      _this.queryParams.current=page
      _this.queryParams.size=_this.$refs.pagination.size

      _this.orderJs.getOrderPreList(_this.queryParams)
        .then(response => {
          _this.tableData = response.data.data.rows
          _this.$refs.pagination.render(page, response.data.data.total)
        })
    },

    download() {
      let _this = this
      _this
        .$confirm('由于导出数据需要一定时间，请确定是否需要下载。', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          _this.orderJs.importOrderPreList(_this.queryParams)
            .then(res => {
              if(res.data.code==='0'){
                _this.$alert(res.data.data)
              }else{
                _this.$alert(res.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消！'
          })
        })
    }
  }
}
</script>

<style>
._select {
  width: 20%;
  height: 34px;
}

.pup {
  float: right;
}

.col-md-3 {
  float: left;
}
.box {
  display: flex;
  flex-wrap: wrap;
}
</style>
<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }



/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}

</style>